exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7379ca52] .el-tabs__content{height:calc(100% - 60px)!important}", ""]);

// exports
